// ─── Game Constants ─────────────────────────────────────────────
export const ARENA_RADIUS = 38;
export const ARENA_WALL_HEIGHT = 6;
export const PLAYER_SPEED = 20;
export const PLAYER_RADIUS = 1.0;
export const PLAYER_HEIGHT = 3.2;
export const PLAYER_SPRINT_MULT = 1.45;
export const PLAYER_ACCEL = 55;           // acceleration per second
export const PLAYER_FRICTION = 8;         // deceleration multiplier when no input
export const PLAYER_DASH_SPEED = 35;
export const PLAYER_DASH_DUR = 0.15;
export const PLAYER_DASH_COOLDOWN = 1.2;

// Health
export const MAX_HP = 100;
export const ROUNDS_TO_WIN = 2;

// Weapons
export const ROCK_DAMAGE = 25;
export const SCISSORS_DAMAGE = 18;
export const SCISSORS_VS_PAPER_MULTIPLIER = 2.0;
export const ROCK_SPEED = 32;
export const ROCK_COOLDOWN = 1.5;
export const SCISSORS_COOLDOWN = 0.7;
export const PAPER_COOLDOWN = 0.3;
export const SCISSORS_RANGE = 5.5;
export const ROCK_LIFETIME = 4.0;

// Visual
export const P1_COLOR = 0x2196F3;
export const P2_COLOR = 0xF44336;
export const P1_COLOR_HEX = '#2196F3';
export const P2_COLOR_HEX = '#F44336';
export const SAND_COLOR = 0xd4a574;
export const STONE_COLOR = 0x8B8680;
export const STONE_DARK = 0x6B6560;
export const COLUMN_COLOR = 0xC8B8A0;

// Camera – local (top-down)
export const LOCAL_CAM_HEIGHT = 60;

// Camera – online TPS/FPS
export const TPS_DISTANCE = 10;
export const TPS_HEIGHT = 5;
export const FPS_EYE_HEIGHT = 3.1;
export const CAM_SHAKE_DECAY = 6;         // how fast screenshake fades

// Network
export const NET_TICK_RATE = 20;
export const NET_INTERPOLATION_DELAY = 100;

// Gameplay
export const RESPAWN_DELAY = 2.0;
export const ROUND_START_COUNTDOWN = 3;
export const KNOCKBACK_FORCE = 12;
export const INVULN_TIME = 0.3;

// Zone
export const ZONE_START_DELAY = 30;       // seconds before zone starts shrinking
export const ZONE_SHRINK_RATE = 0.5;      // units per second (slow creep)
export const ZONE_MIN_RADIUS = 8;
export const ZONE_DAMAGE_PER_SEC = 5;
export const ZONE_WARNING_TIME = 5;       // seconds before shrink to warn

// ── Controls ───────────────────────────────────────────
// P1: ZQSD (AZERTY physical) = KeyW/KeyA/KeyS/KeyD codes
// Weapons P1: &(1)/é(2)/\"(3) = Digit1/Digit2/Digit3
// P2: Arrows + Numpad 1/2/3
export const CONTROLS = {
  p1: {
    up:       'KeyW',        // Z on AZERTY
    down:     'KeyS',
    left:     'KeyA',        // Q on AZERTY
    right:    'KeyD',
    rock:     'KeyX',        // X → rock
    paper:    'KeyC',        // C → paper (hold)
    scissors: 'KeyV',        // V → scissors
    dash:     'Space',       // Space → dash
  },
  p2: {
    up:       'ArrowUp',
    down:     'ArrowDown',
    left:     'ArrowLeft',
    right:    'ArrowRight',
    rock:     'Numpad1',
    paper:    'Numpad2',
    scissors: 'Numpad3',
    dash:     'Numpad0',
  }
};

// Camera toggle keys (online mode only)
export const KEY_CAM_FPS = 'KeyF';   // F → first-person
export const KEY_CAM_TPS = 'KeyG';   // G → third-person
